<p>Group Name: {{ groupIdentifier.Name }}</p>

<div class="post-load" *ngIf="group != null">
  <p *ngFor="let uda of group.UserDefinedAttributes">
    <span>{{ uda.AttributeName }}</span>
    <span>{{ uda.AttributeType }}</span>
  </p>
</div>
